import React, { useState } from "react";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import appRoutes from "../../../routes/app.routes";
import { VIDEO_CAROUSEL, VIDEO_STEPS } from "../homeV2.constants";
import HvButton from "./HvButton";
import Reveal from "./Reveal";

// Position of a card relative to the active one, wrapped to the shortest
// direction around the loop — drives which "receding to the side" class it
// gets (see .hv2-video-mockup--prev/next/far in _homeV2.scss).
const getPositionClass = (index: number, activeIndex: number, total: number) => {
  let offset = index - activeIndex;
  if (offset > total / 2) offset -= total;
  if (offset < -total / 2) offset += total;
  if (offset === 0) return "hv2-video-mockup--active";
  if (offset === -1) return "hv2-video-mockup--prev";
  if (offset === 1) return "hv2-video-mockup--next";
  return "hv2-video-mockup--far";
};

const VideoProfiles = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const showPrev = () => setActiveIndex((current) => (current === 0 ? VIDEO_CAROUSEL.length - 1 : current - 1));
  const showNext = () => setActiveIndex((current) => (current === VIDEO_CAROUSEL.length - 1 ? 0 : current + 1));

  return (
    <section className="hv2-video-profiles" id="video-profiles">
      <div className="home-v2__container hv2-video-profiles__grid">
        <Reveal>
          <span className="home-v2__label">Introducing Video Profiles</span>
          <h2 className="home-v2__h2 hv2-video-profiles__title">
            Your experience deserves more than <span className="home-v2__highlight">six seconds</span> of attention
          </h2>
          <p className="home-v2__body-lg hv2-video-profiles__sub">
            Record a 60-second introduction and let employers see the person behind the resume.
          </p>
          <div className="hv2-video-profiles__steps">
            {VIDEO_STEPS.map((step) => (
              <div className="hv2-video-profiles__step" key={step.num}>
                <span className="num">{step.num}</span> {step.label}
              </div>
            ))}
          </div>
          <HvButton variant="primary" to={appRoutes.userSignUp.path}>
            Create your profile →
          </HvButton>
        </Reveal>

        <Reveal delay={0.08} className="hv2-video-profiles__visual">
          <div className="hv2-video-carousel">
            {VIDEO_CAROUSEL.map((video, index) => (
              <div
                className={`hv2-video-mockup ${getPositionClass(index, activeIndex, VIDEO_CAROUSEL.length)}`}
                style={{ backgroundImage: `linear-gradient(rgba(26, 26, 46, 0.4), rgba(26, 26, 46, 0.9)), url(${video.photo})` }}
                key={video.name}
                aria-hidden={index !== activeIndex}
              >
                <div className="play-big">
                  <PlayArrowIcon style={{ color: "#fff", fontSize: 28 }} />
                </div>
                <div className="caption">
                  <strong>{video.name}</strong> · {video.role}
                  <br />
                  &quot;{video.quote}&quot;
                </div>
              </div>
            ))}
            <button type="button" className="hv2-carousel-nav hv2-carousel-nav--prev" aria-label="Previous video" onClick={showPrev}>
              <ArrowBackIcon fontSize="small" />
            </button>
            <button type="button" className="hv2-carousel-nav hv2-carousel-nav--next" aria-label="Next video" onClick={showNext}>
              <ArrowForwardIcon fontSize="small" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default VideoProfiles;
